import type {Module} from "vuex";
import type {RootState} from "@/store/types";

import approvals from "./user/approval"
import checkout from "./user/checkout"
import delegate from "./user/delegate"

const user: Module<Record<string, never>, RootState> = {
    namespaced: true,
    actions: {
        clear(context) {

            context.dispatch("approvals/clear");
            context.dispatch("checkout/clear");
            context.dispatch("delegate/clear");
        }
    },
    modules: {
        approvals,
        checkout,
        delegate
    }
}

export default user
